import { type AggRequest, type AggResponse, fetchAgg } from '../../../../common/utils/fetch-agg';
import {
	mutateOperationName,
	mutateOperationNameV1,
	operationName,
	operationNameV1,
	quickFindMutateZeroQueriesMutation,
	quickFindMutateZeroQueriesMutationV1,
	quickFindZeroQueriesQuery,
	quickFindZeroQueriesQueryV1,
} from './query';
import {
	type MutateZeroQueriesMutationType,
	type MutateZeroQueriesMutationTypeV1,
	type MutateZeroQueriesMutationVariables,
	type QuickFindZeroQueriesQueryType,
	type QuickFindZeroQueriesQueryTypeV1,
	type QuickFindZeroQueriesQueryVariables,
} from './types';

export type QuickFindZeroQueriesQueryProps = Pick<
	AggRequest<QuickFindZeroQueriesQueryVariables>,
	'aggAbsoluteUrl' | 'variables'
> & { headers: Record<string, string> };

export const zeroQueriesQuery: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesQueryProps) => Promise<AggResponse<QuickFindZeroQueriesQueryType>> = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesQueryProps) => {
	return fetchAgg<QuickFindZeroQueriesQueryVariables, QuickFindZeroQueriesQueryType>({
		aggAbsoluteUrl,
		graphQuery: quickFindZeroQueriesQuery,
		variables,
		operationName,
		headers,
	});
};

export const zeroQueriesQueryV1: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesQueryProps) => Promise<AggResponse<QuickFindZeroQueriesQueryTypeV1>> = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesQueryProps) => {
	return fetchAgg<QuickFindZeroQueriesQueryVariables, QuickFindZeroQueriesQueryTypeV1>({
		aggAbsoluteUrl,
		graphQuery: quickFindZeroQueriesQueryV1,
		variables,
		operationName: operationNameV1,
		headers,
	});
};

export type QuickFindZeroQueriesMutationProps = Pick<
	AggRequest<MutateZeroQueriesMutationVariables>,
	'aggAbsoluteUrl' | 'variables'
> & { headers: Record<string, string> };

export const zeroQueriesMutation: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesMutationProps) => Promise<AggResponse<MutateZeroQueriesMutationType>> = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesMutationProps) => {
	return fetchAgg<MutateZeroQueriesMutationVariables, MutateZeroQueriesMutationType>({
		aggAbsoluteUrl,
		graphQuery: quickFindMutateZeroQueriesMutation,
		variables,
		operationName: mutateOperationName,
		headers,
	});
};

export const zeroQueriesMutationV1: ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesMutationProps) => Promise<AggResponse<MutateZeroQueriesMutationTypeV1>> = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: QuickFindZeroQueriesMutationProps) => {
	return fetchAgg<MutateZeroQueriesMutationVariables, MutateZeroQueriesMutationTypeV1>({
		aggAbsoluteUrl,
		graphQuery: quickFindMutateZeroQueriesMutationV1,
		variables,
		operationName: mutateOperationNameV1,
		headers,
	});
};
